import React, { CSSProperties, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import AccessDenied from './components/AccessDenied';

const App: React.FC = () => {
  const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0();
  const location = useLocation();
  const isAccessDenied = new URLSearchParams(location.search).get('error') === 'access_denied';

  useEffect(() => {
    if (isAccessDenied) {
      return;
    }
    if (!isLoading && !isAuthenticated && !error) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, error, isAccessDenied]);

  const containerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '1.5rem',
  };

  if (isAccessDenied) {
    return <AccessDenied />;
  }

  if (error) {
    return <div style={containerStyle}>Authentication error: {error.message}</div>;
  }

  if (isLoading) {
    return <div style={containerStyle}>Loading ...</div>;
  }

  return (
    <Routes>
      <Route path="/" element={isAuthenticated ? <Home /> : null} />
    </Routes>
  );
};

export default App;